/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  query RatePlanReadQuery($rateId: ID!, $operatorNameToSearch: String, $mccNameToSearch: String, $mncNameToSearch: String, $countryNameToSearch: String, $take: PositiveInt, $skip: Int) {
    RatePlanRead(rateId: $rateId, operatorNameToSearch: $operatorNameToSearch, mccNameToSearch: $mccNameToSearch, mncNameToSearch: $mncNameToSearch, countryNameToSearch: $countryNameToSearch, take: $take, skip: $skip) {
      id
      createdAt
      updatedAt
      smsType,
      rate,
      message,
      status,
      _totalCount,
      Account {
        id,
        displayName
      },
      Rate {
        id
        displayName,
        currency
      }
      Mcc {
        mcc,
        countryName
      },
      Mnc {
        mnc,
        network
      },
      SenderIdDirectory {
        createdAt,
        updatedAt,
        displayName
      },
      SenderId {
        createdAt,
        updatedAt,
        senderId
      },
      PhoneNumberoDirectory {
        createdAt,
        updatedAt,
        displayName
      },
      PhoneNumbero {
        createdAt,
        updatedAt,
        phoneNumbero
      }
    }
  }
`
